import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
declare var $: any;

@Component({
  selector: 'app-mondial-relay',
  templateUrl: './mondial-relay.component.html',
  styleUrls: ['./mondial-relay.component.css']
})
export class MondialRelayComponent implements OnInit {

  innerHeight: number = window.innerHeight;

  @ViewChild('mrWidget') mrWidget: ElementRef|any;
  @ViewChild('selectedRelay') selectedRelayComp: ElementRef|any;

  pointOfSale: any = this.tools.getStor("point_of_sale");
  selectedRelay: any;
  delivryAddress: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialogRef: MatDialogRef<MondialRelayComponent>,
    private tools: ToolsService
  ) {
    this.selectedRelay = data.relay;
    this.delivryAddress = data.delivryAddress;
  }

  ngOnInit() {
    this.initMondialRelayWidget();
  }

  /**
   * @description Initialise le widget mondial relay
   * @returns {void}
   */
  initMondialRelayWidget(): void {

    const that = this;

    /**
     * On récupère les pays éligibiles
     */
    let allowedCountries :any= [];
    this.pointOfSale.shipping_costs.map((cost:any) => {
      if (cost.is_relay > 0) {
        cost.countries.map((country:any) => {
          allowedCountries.push(country.code);
        })
      }
    })

    /**
     * On récupère le code postal et le pays pour la recherche par défaut
     */
    let postalCode = this.selectedRelay ? this.selectedRelay.CP : this.delivryAddress ? this.delivryAddress.postal : "75000";
    let countryCode = this.selectedRelay ? this.selectedRelay.Pays : this.delivryAddress ? this.delivryAddress.country_code : "FR";


    $("#Zone_Widget").MR_ParcelShopPicker(
      {
        Target: "#Target_Widget",
        Brand: this.pointOfSale.mondial_relay_account, // Votre code client Mondial Relay TODO
        Country: countryCode, // Code ISO 2 lettres du pays utilisé pour la recherch
        Responsive: true,
        PostCode: postalCode,
        ShowResultsOnMap: true,
        MapScrollWhee: true,
        AllowedCountries: allowedCountries,
        ColLivMod: "24R",
        EnableGeolocalisatedSearch: true,
        OnParcelShopSelected: function (relay:any) {
          that.selectedRelay = relay;
          setTimeout(() => {
            const objDiv:any = document.getElementById("selectedrelaycomp");
            objDiv.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
          });
        }

      });
  }

  /**
   * @description Confirme la selection du relais et ferme la dialog
   * @returns {void}
   */
  selectRelay(): void {
    this.selectedRelay.Num = this.selectedRelay.Pays + "-" + this.selectedRelay.ID;
    this.dialogRef.close(this.selectedRelay);
  }

  /**
   * @description Ferme la fenetre de dialog
   */
  closeDial(): void {
    this.dialogRef.close();
  }

}
